import React, { Component } from 'react';
import Navbar from '../../../_components/common/Navbar';
import { CommonBreadCrumb } from '../../../_components/common/CommonBreadCrumb';
import Settings from '../../../_components/common/SettingsHeader';
import TableNew from '../../../_components/common/TableNew';
import { renderers } from 'handsontable';
import { connect } from 'react-redux';
import Buttons from '../../../_components/common/Button';


class ReportContent extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }
    render() {
        return (
            < div >
                <Navbar />

                <div className="container custom-container my-5" >

                    <div>
                        <CommonBreadCrumb
                            data={[
                                {
                                    link: '/admin/app/dashboard',
                                    name: 'ADMIN'
                                }, {
                                    link: '',
                                    name: 'REPORT CONTENT'
                                }
                            ]}
                        />
                    </div>

                    <div className="bg-green rounded-top position-relative">
                        <p className="text-center text-uppercase py-2 text-white mb-0 quattrocentosans regular"> REPORT CONTENT - LOI</p>
                    </div>

                    <div className="mx-md-5 mx-0 mt-4 pb-5">

                        <div className="d-flex flex-row flex-wrap justify-content-start ">

                            <div className="col-12 col-md-6 col-lg-4 my-2">
                                <Buttons name="ORIENTATION TEXT" link="admin/app/edit-report/vpi/orientation-text" type="btn-block" />
                            </div>

                            <div className="col-12 col-md-6 col-lg-4 my-2">
                                <Buttons name="INFERENCE" link="admin/app/edit-report/vpi/inference" type="btn-block" />
                            </div>

                            <div className="col-12 col-md-6 col-lg-4 my-2">
                                <Buttons name="IMPLICATIONS" link="admin/app/edit-report/vpi/implications" type="btn-block" />
                            </div>

                            <div className="col-12 col-md-6 col-lg-4 my-2">
                                <Buttons name="ACTION ITEMS" link="admin/app/edit-report/vpi/action-items" type="btn-block" />
                            </div>


                        </div>
                    </div>

                    <div className="bg-green rounded-top position-relative">
                        <p className="text-center text-uppercase py-2 text-white mb-0 quattrocentosans regular">REPORT CONTENT - VVI</p>
                    </div>

                    <div className="mx-md-5 mx-0 mt-4 pb-5">

                        <div className="d-flex flex-row flex-wrap justify-content-start ">

                            <div className="col-12 col-md-6 col-lg-4 my-2">
                                <Buttons name="SLOT TEXT" link="admin/app/edit-report/vvi/slot-text" type="btn-block" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {

}

export default connect(mapStateToProps)(ReportContent);



// WEBPACK FOOTER //
// ./src/_pages/Admin/ReportContent/index.jsx